import ErrorScreen from "../../Common/ErrorScreen";
import LoadingScreen from "../../Common/LoadingScreen";
import { PdfViewerAdvanced } from "../../Common/PdfViewerAdvanced";
import useVisorOrdenExterna from "../hooks/useVisorOrdenExterna";

/**
 * Componente principal para carga de la orden en PDF
 * Utiliza token de URL para obtener datos de la orden
 * 
 * @param {Object} props - Props del componente
 * @param {Object} props.message - Estado de mensajes { open, message, severity }
 * @param {Function} props.setMessage - Función para actualizar mensajes
 */
export const VisorOrdenExterna = ({ message, setMessage }) => {

  const {
    pdfOrdenData,
    isLoading,
    error,
    sessionExpired,
  } = useVisorOrdenExterna({ setMessage });

  // Si la sesión expiró, mostrar pantalla de error
  if (sessionExpired) {
    return (
      <ErrorScreen
        error={sessionExpired}
      />
    );
  }

  // Renderizar estado de carga
  if (isLoading) {
    return <LoadingScreen />;
  }

  // Renderizar estado de error
  if (error || !pdfOrdenData) {
    return (
      <ErrorScreen
        error={error}
        onRetry={() => window.location.reload()}
      />
    );
  }

  return (
    <PdfViewerAdvanced file={pdfOrdenData.fileURL} />
  )
}
